// Default chat widget colours, keyed by the same field names brands use in Shopify/<shopId>.Color_Theme.
// A brand only needs to set the fields it wants to override; everything else falls back to these.
export const DEFAULT_COLOR_THEME = {
  headerColor: "linear-gradient(135deg, #3FA58D 0%, #6CC7B3 100%)", // header bar (any CSS background)
  headerTextColor: "#FFFFFF",     // header title + icons
  primaryColor: "#FFFFFF",        // bot message bubbles
  textSecondaryColor: "#1F2937",  // "Powered by" text + loader dots
  secondaryColor: "#D6F1EA",      // user message bubble
  textPrimaryColor: "#1F2937",    // user message text
  bubble_Sender: "#1F2937",       // bot message text
  accentColor: "#4FB39C",         // round buttons, icons, welcome text
  buttonTextColor: "#FFFFFF",     // text/icons on accent buttons
  backgroundColor: "linear-gradient(160deg, #FDFBEA 0%, #F2F8EC 45%, #DDF2EB 100%)", // chat body (any CSS background)
};

// Maps each Color_Theme field to the CSS variable(s) the widget's Tailwind classes read.
const CSS_VARIABLES_BY_THEME_FIELD = {
  headerColor: ["--color-headerbar"],
  headerTextColor: ["--color-headerbartext"],
  primaryColor: ["--color-header", "--color-footer", "--color-primary1"],
  textSecondaryColor: ["--color-headertext"],
  secondaryColor: ["--color-bubble"],
  textPrimaryColor: ["--color-text"],
  bubble_Sender: ["--color-bubbletext"],
  accentColor: ["--color-buttonbackground"],
  buttonTextColor: ["--color-buttontext"],
  backgroundColor: ["--color-chatbackground"],
};

// Header fields fall back to these older fields, so brands that styled their header via primaryColor keep that look.
const LEGACY_FALLBACK_FIELD = {
  headerColor: "primaryColor",
  headerTextColor: "textSecondaryColor",
};

// Applies the default theme overlaid with the brand's Color_Theme (if any) to the document's CSS variables.
export function applyColorTheme(brandColorTheme = {}) {
  const brandTheme = brandColorTheme || {};
  const mergedTheme = { ...DEFAULT_COLOR_THEME };
  Object.entries(brandTheme).forEach(([field, value]) => {
    if (value) mergedTheme[field] = value;
  });
  Object.entries(LEGACY_FALLBACK_FIELD).forEach(([field, legacyField]) => {
    if (!brandTheme[field] && brandTheme[legacyField]) mergedTheme[field] = brandTheme[legacyField];
  });

  Object.entries(CSS_VARIABLES_BY_THEME_FIELD).forEach(([field, cssVariables]) => {
    cssVariables.forEach((cssVariable) => {
      document.documentElement.style.setProperty(cssVariable, mergedTheme[field]);
    });
  });
}
